import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { Subscription } from 'src/features/subscriptions/utils/types';
import { SubscriptionFormSchemaValues } from 'src/features/subscriptions/utils/formSchema';

const RESOURCE = '/subscriptions/subscription/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: SubscriptionFormSchemaValues): Promise<Subscription> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSubscription };
